import { Hexagon, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import { scrollToId } from "@/components/Header";

const Footer = ({ onJoin }) => (
  <footer data-testid="footer-container" className="bg-zinc-900 text-zinc-400 py-14">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="flex flex-col md:flex-row md:items-start justify-between gap-10">
        <div className="max-w-sm">
          <div className="flex items-center gap-2 font-display font-extrabold text-lg text-white">
            <span className="grid place-items-center w-8 h-8 rounded-xl bg-amber-400 text-zinc-900">
              <Hexagon className="w-5 h-5" strokeWidth={2.5} />
            </span>
            HoneyGain<span className="text-amber-400">Deals</span>
          </div>
          <div data-testid="footer-operator-block" className="mt-5 rounded-2xl border border-zinc-800 bg-zinc-800/40 p-5">
            <p className="text-xs font-bold uppercase tracking-widest text-amber-400">Who runs this page</p>
            <p className="mt-2 text-sm leading-relaxed text-zinc-300">
              HoneyGain Deals is run by an independent Honeygain user and affiliate. When you join
              through a link here, Honeygain pays a referral commission — it costs you nothing, and
              you start with a $3 bonus.
            </p>
            <Link
              to="/about"
              data-testid="footer-about-link"
              className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-amber-400 hover:text-amber-300 transition-colors"
            >
              More about this site
            </Link>
          </div>
          <p data-testid="footer-affiliate-disclosure" className="mt-4 text-xs leading-relaxed text-zinc-500">
            Affiliate disclosure: this is an independent promotional page and is not operated by
            Honeygain or TrafficAdBar. Links to both services earn the owner a referral commission
            at no extra cost to you. Honeygain and TrafficAdBar are products of their respective owners.
          </p>
        </div>

        <div className="flex gap-14">
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-zinc-500">Explore</p>
            <ul className="mt-4 space-y-2.5 text-sm">
              {[
                ["how-it-works", "How it works"],
                ["earnings", "Earnings"],
                ["security", "Security"],
                ["faq", "FAQ"],
                ["testimonials", "Proof"],
              ].map(([id, label]) => (
                <li key={id}>
                  <button
                    onClick={() => scrollToId(id)}
                    className="hover:text-amber-400 transition-colors"
                    data-testid={`footer-link-${id}`}
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-zinc-500">Get started</p>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <a href="/blog" className="text-zinc-400 hover:text-amber-400 transition-colors" data-testid="footer-link-blog">
                  Blog
                </a>
              </li>
              <li>
                <Link to="/about" className="text-zinc-400 hover:text-amber-400 transition-colors" data-testid="footer-link-about">
                  About
                </Link>
              </li>
              <li>
                <button
                  onClick={() => onJoin("footer")}
                  className="inline-flex items-center gap-1.5 text-amber-400 font-semibold hover:text-amber-300 transition-colors"
                  data-testid="footer-join-link"
                >
                  Join with $3 bonus <ExternalLink className="w-3.5 h-3.5" />
                </button>
              </li>
            </ul>
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-zinc-500">Guides</p>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/blog/earn-crypto-online" className="text-zinc-400 hover:text-amber-400 transition-colors" data-testid="footer-link-earn-crypto-online">
                  Earn Crypto Online
                </Link>
              </li>
              <li>
                <Link to="/blog/is-honeygain-safe-reddit" className="text-zinc-400 hover:text-amber-400 transition-colors" data-testid="footer-link-is-honeygain-safe">
                  Is Honeygain Safe?
                </Link>
              </li>
              <li>
                <Link to="/blog/honeygain-vs-alternatives" className="text-zinc-400 hover:text-amber-400 transition-colors" data-testid="footer-link-honeygain-vs">
                  Honeygain vs Alternatives
                </Link>
              </li>
              <li>
                <Link to="/blog/earn-passive-income-daily" className="text-zinc-400 hover:text-amber-400 transition-colors" data-testid="footer-link-earn-passive-income">
                  Earn Passive Income Daily
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="mt-12 pt-6 border-t border-zinc-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-zinc-500">
        <p>© {new Date().getFullYear()} HoneyGainDeals. Independent affiliate page.</p>
        <p className="flex items-center gap-4">
          Earnings vary by location and network demand. Not financial advice.
          <a href="/stats" data-testid="footer-stats-link" className="hover:text-amber-400 transition-colors">Stats</a>
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
